import { DateTime } from 'luxon';
var FORMATS = ['MM/dd/yy', 'MM/dd/yyyy', 'D', 'DD', 'DDD'];
var DEFAULT_DATE_FORMAT = 'DD';
var dateToString = function (date) { return date.toFormat(DEFAULT_DATE_FORMAT); };
var transformDatePickerValues = function (value, selectRange) {
    var dateValues = {
        dateFrom: undefined,
        dateTo: undefined,
    };
    if (selectRange && Array.isArray(value)) {
        dateValues.dateFrom = value ? value[0] : undefined;
        dateValues.dateTo = value ? value[1] : undefined;
    }
    else if (Array.isArray(value)) {
        dateValues.dateFrom = value[0];
    }
    else {
        dateValues.dateFrom = value;
    }
    return dateValues;
};
var transformDateTimeValuesDownstream = function (value) {
    return {
        dateFrom: value.dateFrom ? downstreamTzTransform(value.dateFrom) : undefined,
        dateTo: value.dateTo ? downstreamTzTransform(value.dateTo) : undefined,
    };
};
var transformComparativeDates = function (dateTime) {
    var nextDate = dateTime.toJSDate();
    var day = dateTime.day, month = dateTime.month, year = dateTime.year;
    nextDate.setSeconds(0);
    nextDate.setMinutes(0);
    nextDate.setHours(0);
    nextDate.setDate(day);
    nextDate.setMonth(month - 1);
    nextDate.setFullYear(year);
    return nextDate;
};
var downstreamTzTransform = function (dateTime) {
    var nextDate = dateTime.toJSDate();
    var second = dateTime.second, minute = dateTime.minute, hour = dateTime.hour, day = dateTime.day, month = dateTime.month, year = dateTime.year;
    nextDate.setSeconds(second);
    nextDate.setMinutes(minute);
    nextDate.setHours(hour);
    nextDate.setDate(day);
    nextDate.setMonth(month - 1);
    nextDate.setFullYear(year);
    return nextDate;
};
var upstreamTzTransform = function (date, oldDate) {
    if (oldDate === void 0) { oldDate = DateTime.now(); }
    var second = oldDate.second, minute = oldDate.minute, hour = oldDate.hour;
    var nextDay = date.getDate();
    var nextMonth = date.getMonth();
    var nextYear = date.getFullYear();
    return oldDate.set({
        day: nextDay,
        hour: hour,
        minute: minute,
        month: nextMonth + 1,
        second: second,
        year: nextYear,
    });
};
var getValidDateFromString = function (dateString) {
    var date;
    for (var _i = 0, FORMATS_1 = FORMATS; _i < FORMATS_1.length; _i++) {
        var format = FORMATS_1[_i];
        date = DateTime.fromFormat(dateString, format);
        if (date.isValid) {
            return date;
        }
    }
    return date;
};
export { dateToString, getValidDateFromString, transformDatePickerValues, upstreamTzTransform, downstreamTzTransform, transformDateTimeValuesDownstream, transformComparativeDates, };
